import { createElementBlock as r, openBlock as t, createElementVNode as e } from "vue";
/* empty css                 */
import n from "../../_virtual/_plugin-vue_export-helper.js";
const s = {
  name: "DsIconLoader"
}, c = {
  width: "18",
  height: "18",
  viewbox: "0 0 18 18",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "ds-icon-loader"
};
function l(i, o, a, d, p, m) {
  return t(), r("svg", c, o[0] || (o[0] = [
    e("circle", {
      class: "circle",
      cx: "9",
      cy: "9",
      r: "8"
    }, null, -1),
    e("path", {
      class: "path",
      d: "M9 17C4.58172 17 0.999999 13.4183 1 9C1 4.58172 4.58172 0.999999 9 1C13.4183 1 17 4.58172 17 9"
    }, null, -1)
  ]));
}
const h = /* @__PURE__ */ n(s, [["render", l]]);
export {
  h as default
};
